module.exports = __webpack_public_path__ + "static/connectvast-banner-5ce0ee3ea8d9a2186edaedcbc5117a6a.jpg";